__turbopack_context__.v({
  "container": "AvisoPrivacidad-module__XHMk9q__container",
  "container__forma": "AvisoPrivacidad-module__XHMk9q__container__forma",
  "container__logo": "AvisoPrivacidad-module__XHMk9q__container__logo",
  "container__wrapper": "AvisoPrivacidad-module__XHMk9q__container__wrapper",
});
